import { useState, useEffect, useRef, useCallback } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Transactions/Table";
import SummaryCard from "../../Components/Transactions/SummaryCardNew";
import { toast } from "react-toastify";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapperWithSearch,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useDispatch, useSelector } from "react-redux";
import EditTransactionModel from "../../Components/Transactions/EditTransactions";
import moment from "moment";
import { LargeSummarySkeletonLoading } from "../../Components/SkeletonLoading";
import DateRange from "../../Components/DateRange";
import SearchFilterBox from "../../Components/SearchFilterBox";
import RestorePayment from "../../Components/Transactions/RestorePayment";
import ViewModal from "../../Components/Transactions/ViewModal";
import SideModal from "../../Components/SideModal";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import { IoAnalytics, IoFilter } from "react-icons/io5";
import FilterModal from "../../Components/Transactions/FilterModal";
import { Select_Location } from "../../Redux/actions";
import AnalyticsSideModal from "../../Components/Transactions/AnalyticsSideModal";
import { useLocation } from "react-router-dom";

const FILTER_PARAM_KEYS = [
  "modeFilters",
  "transactionForFilters",
  "recordedByFilters",
  "settlementFilters",
  "locationFilters",
];

const EMPTY_FILTER = {
  modeFilters: "",
  transactionForFilters: "",
  recordedByFilters: "",
  settlementFilters: "",
  locationFilters: "",
};
const EMPTY_ACTIVE_FILTER = { value: "", label: "", title: "" };
const ALL_LOCATIONS = { id: 0, name: "All Locations", clientId: 0 };

const Transactions = () => {
  const locationState = useLocation();
  const navState = locationState.state || {};
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
    { label: "Recorded By", value: 3 },
    { label: "Room No", value: 5 },
    { label: "Property", value: 4 }
  ];
  const dispatch = useDispatch();
  const storageKey = `tenant_collections_filter`;
  const user = useSelector((state) => state.UserReducer.user);
  const properties = useSelector((state) => state.PropertyReducer.property);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const location = useSelector(
    (state) => state.SelectLocationReducer.selectLocation
  );
  const [isShowAnalytics, setIsShowAnalytics] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState({
    modeFilters: "",
    transactionForFilters: "",
    recordedByFilters: "",
    settlementFilters: "",
    locationFilters: "",
  });
  const [isFocused, setIsFocused] = useState(false);
  const [isRestorePayment, setIsRestorePayment] = useState(false);
  const [masterData, setMasterData] = useState();
  const [apiData, setApiData] = useState();
  const [summary, setSummary] = useState();
  const [bankSummary, setBankSummary] = useState();
  const [staffList, setStaffList] = useState([]);


  const [viewDetail, setViewDetail] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [selectedProperty, setSelectedProperty] = useState(property);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [activeFilter, setActiveFilter] = useState({
    value: "",
    label: "",
    title: "",
  });
  const hasMounted = useRef(false);
  const initialLoadDone = useRef(false);

  const parseFilterValue = (filterValue) => {
    if (!filterValue) return null;

    try {
      return JSON.parse(filterValue);
    } catch (error) {
      return filterValue;
    }
  };

  const formatFilterForDisplay = useCallback((parsedFilter) => {
    if (!parsedFilter?.selectedFilters) return null;

    const { selectedFilters } = parsedFilter;
    const filterCount =
      (selectedFilters.mode?.length || 0) +
      (selectedFilters.dueType?.length || 0) +
      (selectedFilters.collectedBy?.length || 0) +
      (selectedFilters.settlement?.length || 0) +
      (selectedFilters.locations?.length || 0);

    return {
      value: JSON.stringify(selectedFilters),
      label: `Filter (${filterCount})`,
      title: `Multi-Filter: ${filterCount} applied`
    };
  }, []);

  const createLocationFilterObject = useCallback((location) => {
    if (!location || !location.id || location.id === 0) return null;

    return {
      selectedFilters: {
        locations: [{
          value: location.id.toString(),
          label: location.name || `Location ${location.id}`
        }]
      }
    };
  }, []);

  const updateFilterForLocation = useCallback((location) => {
    if (!location || !location.id || location.id === 0) {
      setFilter(prev => ({
        ...prev,
        locationFilters: ''
      }));
      setFilterValue("");
      setActiveFilter({ value: "", label: "", title: "" });
      return;
    }

    const locationFilter = createLocationFilterObject(location);

    if (locationFilter) {
      setFilter(prev => ({
        ...prev,
        locationFilters: location.id.toString()
      }));

      setFilterValue(JSON.stringify(locationFilter.selectedFilters));

      const formattedFilter = formatFilterForDisplay(locationFilter);
      if (formattedFilter) {
        setActiveFilter(formattedFilter);
      }
    }
  }, [createLocationFilterObject, formatFilterForDisplay]);

  // const buildQueryParams = useCallback(() => {
  //   const params = new URLSearchParams();
  //   params.append('startDate', startDate);
  //   params.append('endDate', endDate);
  //   if (selectedProperty?.id) params.append('propId', selectedProperty.id);
  //   if (searchQuery) params.append('s', searchQuery);
  //   if (filterType) params.append('t', filterType);
  //   if (filter?.modeFilters) params.append('modeFilters', filter.modeFilters);
  //   if (filter?.transactionForFilters) params.append('transactionForFilters', filter.transactionForFilters);
  //   if (filter?.recordedByFilters) params.append('recordedByFilters', filter.recordedByFilters);
  //   if (filter?.settlementFilters) params.append('settlementFilters', filter.settlementFilters);
  //   if (filter?.locationFilters) params.append('locationFilters', filter.locationFilters);

  //   return params.toString();
  // }, [startDate, endDate, selectedProperty, searchQuery, filterType, filter]);

  const buildParams = useCallback(() => {
    const params = new URLSearchParams();
    params.append("startDate", startDate);
    params.append("endDate", endDate);
    if (selectedProperty?.id) params.append("propId", selectedProperty.id);
    if (searchQuery) params.append("s", searchQuery);
    if (filterType) params.append("t", filterType);
    FILTER_PARAM_KEYS.forEach((key) => {
      if (filter?.[key]) params.append(key, filter[key]);
    });
    return params;
  }, [
    startDate,
    endDate,
    selectedProperty?.id,
    searchQuery,
    filterType,
    filter?.modeFilters,
    filter?.transactionForFilters,
    filter?.recordedByFilters,
    filter?.settlementFilters,
    filter?.locationFilters,
  ]);

  const fetchFunction = useCallback(async () => {
    const response = await axios.get(
      `${Config.apiUrl}/transaction/list/web?${buildParams().toString()}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  }, [buildParams, user?.token]);

  const getSuccess = (res) => {
    if (res.isSuccess === false) {

    } else {
      setApiData(res?.data?.transactions);
      setMasterData(res?.data?.transactions);
      setSummary(res?.data?.summary);
      setBankSummary(res?.data?.accountSummary);
      setStaffList(res?.data?.staffs);
      setIsFocused(true);
    }
  };

  const getError = (res) => {
    //console.error("Error fetching transactions:", res);
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    updateFilterForLocation(location);
  }, [location, updateFilterForLocation]);

  // useEffect(() => {
  //   if (hasMounted.current) return;
  //   hasMounted.current = true;

  //   const savedStart = sessionStorage.getItem("collection_startDate");
  //   const savedEnd = sessionStorage.getItem("collection_endDate");
  //   const storageFilter = sessionStorage.getItem(storageKey);

  //   if (savedStart && savedEnd) {
  //     setStartDate(savedStart);
  //     setEndDate(savedEnd);
  //   }

  //   const timer = setTimeout(() => {
  //     if (!initialLoadDone.current) {
  //       getListMutate();
  //       initialLoadDone.current = true;
  //     }
  //   }, 50);

  //   return () => clearTimeout(timer);
  // }, [formatFilterForDisplay]);

  useEffect(() => {
    if (hasMounted.current) return;
    hasMounted.current = true;

    const savedStart = sessionStorage.getItem("collection_startDate");
    const savedEnd = sessionStorage.getItem("collection_endDate");

    const navStart = navState?.startDate;
    const navEnd = navState?.endDate;
    const navPropId = navState?.propId;

    if (navStart && navEnd) {
      const mStart = moment(navStart, "YYYY-MM-DD", true);
      const mEnd = moment(navEnd, "YYYY-MM-DD", true);

      if (mStart.isValid() && mEnd.isValid()) {
        setStartDate(mStart.format("YYYY-MM-DD"));
        setEndDate(mEnd.format("YYYY-MM-DD"));
        sessionStorage.setItem("collection_startDate", mStart.format("YYYY-MM-DD"));
        sessionStorage.setItem("collection_endDate", mEnd.format("YYYY-MM-DD"));
      }
    } else if (savedStart && savedEnd) {
      setStartDate(savedStart);
      setEndDate(savedEnd);
    }

    if (navPropId !== undefined && navPropId !== null) {
      const id = Number(navPropId);
      if (!Number.isNaN(id)) {
        const matched = properties?.find((p) => p.id === id);
        setSelectedProperty(matched ?? { id });
      }
    }

    const timer = setTimeout(() => {
      if (!initialLoadDone.current) {
        getListMutate();
        initialLoadDone.current = true;
      }
    }, 50);

    return () => clearTimeout(timer);
  }, []); // run once on mount

  useEffect(() => {
    if (startDate) sessionStorage.setItem("collection_startDate", startDate);
    if (endDate) sessionStorage.setItem("collection_endDate", endDate);
  }, [startDate, endDate]);

  useEffect(() => {
    if (!hasMounted.current || !initialLoadDone.current) return;

    const timer = setTimeout(() => {
      getListMutate();
    }, 300);

    return () => clearTimeout(timer);
  },
    // [filter, selectedProperty, startDate, endDate, searchQuery, filterType]);
    [
      startDate,
      endDate,
      selectedProperty?.id,
      searchQuery,
      filterType,
      filter?.modeFilters,
      filter?.transactionForFilters,
      filter?.recordedByFilters,
      filter?.settlementFilters,
      filter?.locationFilters
    ]);
  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setFilterType("");
    setSearchQuery("");
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
  };

  const handleFilterChange = (values) => {
    sessionStorage.removeItem("tenant_collections_page");
    sessionStorage.removeItem(storageKey);
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    setSelectedId(null);
    const locationFilterValue = location && location.id && location.id !== 0 ? location.id.toString() : '';
    setFilter({
      modeFilters: '',
      transactionForFilters: '',
      recordedByFilters: '',
      settlementFilters: '',
      locationFilters: locationFilterValue

    });
    if (location && location.id && location.id !== 0) {
      const locationFilter = createLocationFilterObject(location);
      if (locationFilter) {
        setFilterValue(JSON.stringify(locationFilter.selectedFilters));
        const formattedFilter = formatFilterForDisplay(locationFilter);
        if (formattedFilter) {
          setActiveFilter(formattedFilter);
        }
      }
    } else {
      setFilterValue("");
      setActiveFilter({ value: "", label: "", title: "" });
    }
  };

  const onApplyFilter = (selectedFilters) => {
    sessionStorage.removeItem("tenant_collections_page");
    setSelectedId(null);
    const modeFilters = selectedFilters.mode.map(f => f.value).join(',') || '';
    const transactionForFilters = selectedFilters.dueType.map(f => f.value).join(',') || '';
    // const recordedByFilters = selectedFilters.collectedBy.map(f => f.value).join(',') || '';
    const recordedByFilters = selectedFilters.collectedBy.map(f => f.label).join(',') || '';
    const settlementFilters = selectedFilters.settlement.map(f => f.value).join(',') || '';
    let locationFiltersArray = [...selectedFilters.locations];
    const hasLocationFilters = locationFiltersArray.length > 0;

    if (location && location.id && location.id !== 0) {
      const locationExists = locationFiltersArray.some(f => f.value === location.id.toString());
      if (!locationExists) {
        locationFiltersArray.push({
          value: location.id.toString(),
          label: location.name || `Location ${location.id}`
        });
      }
    }

    const locationFilters = locationFiltersArray.map(f => f.value).join(',') || '';

    const formattedFilter = formatFilterForDisplay({
      selectedFilters: {
        ...selectedFilters,
        locations: locationFiltersArray
      }
    });

    setFilter({
      modeFilters,
      transactionForFilters,
      recordedByFilters,
      settlementFilters,
      locationFilters
    });

    setActiveFilter(formattedFilter || {
      value: JSON.stringify(selectedFilters),
      label: "Custom Filter",
      title: "Multi-Filter"
    });

    setFilterValue(JSON.stringify(selectedFilters));
    setIsFilterOpen(false);
    setFilterType("");
    setSearchQuery("");
    if (hasLocationFilters) {
      setSelectedProperty({ id: 0, name: "All Properties", gId: "KIPINN", type: 0, tenantCount: 634, tenantPreference: 3, type: 0 });
    }
  };

  const resetFilters = useCallback(() => {
    setFilter(EMPTY_FILTER);
    setFilterValue("");
    setActiveFilter(EMPTY_ACTIVE_FILTER);
    setSelectedId(null);
    sessionStorage.removeItem(storageKey);
    sessionStorage.removeItem("tenant_collections_page");
    dispatch(Select_Location(ALL_LOCATIONS));
  }, [dispatch, storageKey]);

  const handleClearFiltersTrash = () => {
    setSelectedId(null)
    setActiveFilter({ value: "", label: "", title: "" });
    setFilterValue("");
    sessionStorage.removeItem(storageKey);
    setFilter({
      modeFilters: '',
      transactionForFilters: '',
      recordedByFilters: '',
      settlementFilters: '',
      locationFilters: '',
    });
    setFilterType("");
    setSearchQuery("");
    setIsFilterOpen(false);
    dispatch(Select_Location({ id: 0, name: "All Locations", clientId: 0 }));
  };


  const panelRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    if (!isFilterOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setIsFilterOpen(false);
    };
    const onClickOutside = (e) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      ) {
        setIsFilterOpen(false);
      }
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, [isFilterOpen]);

  //------- Restore Payment -------
  const RestorePaymentFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/transaction/restore`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const restorePaymentSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg);
      setIsRestorePayment(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg);
    }
  };

  const restorePaymentError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: restorePaymentLoading, mutate: restorePaymentMutate } =
    useMutation(RestorePaymentFunction, {
      onSuccess: restorePaymentSuccess,
      onError: restorePaymentError,
    });

  const onSummaryBoxClick = (data) => {
    sessionStorage.removeItem("tenant_collections_page");
    sessionStorage.setItem(storageKey, data);

    let filteredData;
    if (data === "CMS")
      //Security
      filteredData = masterData.filter(
        (transaction) => transaction.transactionFor === 2
      );
    else if (data === "CMR")
      //Rent
      filteredData = masterData.filter(
        (transaction) => transaction.transactionFor === 1
      );
    else if (data === "FINE")
      //Fine
      filteredData = masterData.filter(
        (transaction) => transaction.transactionFor === 10
      );
    else if (data === "OTHERS")
      //Others
      filteredData = masterData.filter(
        (t) => [3, 4, 6, 12, 13, 14, 16, 17, 8, 9, 7, 15, 5].includes(t.transactionFor)
      );
    else if (data === "CMC")
      //Offline
      filteredData = masterData.filter((transaction) => transaction.mode === 1);
    else if (data === "CMO")
      //Online
      filteredData = masterData.filter((transaction) => transaction.mode !== 1);
    else if (data === "App")
      //Online using Kipinn App
      filteredData = masterData.filter(
        (transaction) => transaction.recordedBy === "Kipinn App"
      );
    else filteredData = masterData;

    setApiData(filteredData);
  };

  const buildDownloadQuery = useCallback(() => {
    const params = new URLSearchParams();
    params.append('startDate', startDate);
    params.append('endDate', endDate);
    if (selectedProperty?.id) params.append('propId', selectedProperty.id);
    if (searchQuery) params.append('s', searchQuery);
    if (filterType) params.append('t', filterType);

    if (filter?.modeFilters) params.append('modeFilters', filter.modeFilters);
    if (filter?.transactionForFilters) params.append('transactionForFilters', filter.transactionForFilters);
    if (filter?.recordedByFilters) params.append('recordedByFilters', filter.recordedByFilters);
    if (filter?.locationFilters) params.append('locationFilters', filter.locationFilters);

    params.append('fileType', '1');
    params.append('reportType', '1');

    return params.toString();
  }, [startDate, endDate, selectedProperty?.id, searchQuery, filterType, filter]);

  const [reportUrl, setReportUrl] = useState();

  useEffect(() => {
    if (reportUrl) {
      const link = document.createElement("a");
      link.href = reportUrl;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setReportUrl(null);
    }
  }, [reportUrl]);

  const downloadFunction = async () => {
    const query = buildDownloadQuery();
    const response = await axios.get(
      `${Config.apiUrl}/report/generate?${query}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const onDownloadSuccess = (res) => {
    if (res.isSuccess === false) {
      toast.error(res.msg || "No data found for the selected date range");
    } else if (res.reportUrl === false) {
      toast.error("No data found for the selected date range");
    } else {
      setReportUrl(res.reportUrl);
      toast.success(res.msg || "Report generated successfully");
    }
  };

  const onDownloadError = (res) => {
    toast.error(res.message || "Failed to download report");
  };

  const {
    mutate: downloadReport,
    isLoading: isDownloading,

  } = useMutation(downloadFunction, {
    onSuccess: onDownloadSuccess,
    onError: onDownloadError,
  });

  const handlePropertySelectTrash = (property) => {
    sessionStorage.removeItem("tenant_collections_page");
    sessionStorage.removeItem(storageKey);
    setSelectedProperty(property);
    // handleClearFilters()
    setFilter({
      modeFilters: '',
      transactionForFilters: '',
      recordedByFilters: '',
      settlementFilters: '',
      locationFilters: '',
    });
    setSelectedId(null)
    dispatch(Select_Location({ id: 0, name: "All Locations", clientId: 0 }));
  };

  const handlePropertySelect = (prop) => {
    setSelectedProperty(prop);
    resetFilters();
  };

  const handleClearFilters = () => {
    resetFilters();
    setFilterType("");
    setSearchQuery("");
    setIsFilterOpen(false);
  };

  const handleFilterClose = () => {
    setIsFilterOpen(false);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Collections
            <Underline />
          </BoxTitle>
          <div className="flex space-x-4 md:ml-auto">
            <AnalyticsBtn
              type="button"
              onClick={() => setIsShowAnalytics(true)}
            >
              <IoAnalytics size={14} color="#9CA3AF" />
            </AnalyticsBtn>
            <DownloadBtn type="button" onClick={() => downloadReport()}>
              {isDownloading ? "Downloading..." : "Download"}
            </DownloadBtn>
          </div>
        </BoxHead>

        <SideModal
          isOpen={viewDetail}
          onClose={() => setViewDetail(false)}
        >
          <ViewModal
            setViewDetail={setViewDetail}
            selectedData={selectedData}
          />
        </SideModal>

        {isRestorePayment && (
          <RestorePayment
            setIsRestorePayment={setIsRestorePayment}
            selectedData={selectedData}
            restorePaymentLoading={restorePaymentLoading}
            restorePaymentMutate={restorePaymentMutate}
          />
        )}

        <SideModal
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
        >
          <FilterModal
            setIsFilterOpen={setIsFilterOpen}
            onApplyFilter={onApplyFilter}
            selectedData={selectedData}
            handleClose={handleFilterClose}
            currentFilter={parseFilterValue(filterValue)}
            handleClearFilters={handleClearFilters}
            staffList={staffList}
          />
        </SideModal>

        {(isLoading || isRefetching) && !isFocused && (
          <LargeSummarySkeletonLoading count={5} />
        )}

        <SideModal
          isOpen={isShowAnalytics}
          onClose={() => setIsShowAnalytics(false)}
        >
          <AnalyticsSideModal
            isOpen={isShowAnalytics}
            handleClose={() => setIsShowAnalytics(false)}
            token={user.token}
          />
        </SideModal>

        {isFocused && summary && (
          <>
            <SummaryCard summaryData={summary} onClick={onSummaryBoxClick} selectedId={selectedId} setSelectedId={setSelectedId} />

            <FilterTableWrapper>
              <FilterWrapperWithSearch>
                <div className="flex flex-col md:flex-row md:items-center gap-4">
                  <SearchFilterBox
                    options={searchOptions}
                    handleFilterChange={handleFilterChange}
                    handleClearFilters={handleClearFilters}
                  />
                  <DateRange
                    submitHandler={submitHandler}
                    defaultLabel={
                      moment(startDate).format("DD MMM YYYY") +
                      " - " +
                      moment(endDate).format("DD MMM YYYY")
                    }
                  />
                </div>
                <div className="flex gap-2 justify-end items-center">
                  <PropertiesFilterDropdown
                    properties={properties}
                    selectedProperty={selectedProperty}
                    onPropertySelect={handlePropertySelect}
                    placeholder="Select Property"
                    className="min-w-[200px] w-full md:w-[220px]"
                  />
                  <div className="relative">
                    <FilterBtn
                      ref={btnRef}
                      type="button"
                      title={activeFilter.title || "Open Filter"}
                      onClick={() => setIsFilterOpen((v) => !v)}
                    >
                      <IoFilter size={14} color="#9CA3AF" />
                      {activeFilter?.value && (
                        <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-yellow-500 border border-white" />
                      )}
                    </FilterBtn>
                  </div>
                </div>
              </FilterWrapperWithSearch>
              {!error && !isLoading && data && (
                <TableWrapper>
                  <Table
                    apiData={error ? [] : apiData}
                    setSelectedData={setSelectedData}
                    selectedData={selectedData}
                    setViewDetail={setViewDetail}
                    setIsRestorePayment={setIsRestorePayment}
                    userType={user.userType}
                  />
                  {(error || apiData?.length === 0) && !isLoading && (
                    <NotFoundModel />
                  )}
                </TableWrapper>
              )}
            </FilterTableWrapper>
          </>
        )}
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;
const AnalyticsBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;
const DownloadBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color rounded-md px-6 cursor-pointer bg-white hover:bg-primary-color/5 hover:shadow-md h-full py-2.5 text-sm`;

export default Transactions;

